export const formatDurationInSeconds = (duration: number): string => {
  const minutes = Math.floor(duration / 60)
  const seconds = duration % 60

  const minutesString = minutes.toString().padStart(2, "0")
  const secondsString = seconds.toString().padStart(2, "0")

  return `${minutesString}:${secondsString}`
}
